import { render, staticRenderFns } from "./component-radio.vue?vue&type=template&id=baa8e48c&"
import script from "./component-radio.vue?vue&type=script&lang=js&"
export * from "./component-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports